/* eslint-disable @typescript-eslint/ban-ts-comment */
import * as React from 'react';
import { iframeResizer, } from 'iframe-resizer';
import { CookieConsentContext, } from '@core-front/cookie-consent-provider';
export default class IframeCore extends React.Component {
    constructor(props) {
        super(props);
        this.iframe = null;
        this.handleResize = (data) => {
            // sometimes the load event does not fire
            // but if the iframeResizer lib fires it's resize callback,
            // the iframe has really loaded already
            if (!this.state.hasLoaded) {
                this.setState({
                    hasLoaded: true,
                });
            }
            if (this.props.onResize) {
                this.props.onResize(data);
            }
        };
        this.handleLoad = (event) => {
            if (!this.state.hasLoaded) {
                this.setState({
                    hasLoaded: true,
                });
            }
            if (this.props.onLoad) {
                this.props.onLoad(event);
            }
        };
        this.handleError = (event) => {
            if (this.props.onError) {
                this.props.onError(event);
            }
        };
        this.state = {
            hasLoaded: false,
        };
    }
    componentDidMount() {
        this.initResizer();
    }
    componentDidUpdate() {
        this.initResizer();
    }
    componentWillUnmount() {
        if (this.iframe && this.iframe.iFrameResizer) {
            this.iframe.iFrameResizer
                // removeListeners method does not exist in iframe-resizer typings, so disabling typechecking
                // @ts-ignore
                .removeListeners();
        }
    }
    BEM() {
        const classArray = ['iframe'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    initResizer() {
        const options = {
            checkOrigin: false,
            log: false,
            // onResize method does not exist in iframe-resizer typings, so disabling typechecking
            // @ts-ignore
            onResized: this.handleResize,
        };
        if (this.iframe && !this.iframe.iFrameResizer) {
            iframeResizer(options, this.iframe);
        }
    }
    renderContent() {
        const { Button, Heading, Notice, Overlay, Text } = this.props.components;
        const { needsConsent, consentHeadingLevel } = this.props;
        if (!this.context.hasConsent(needsConsent)) {
            if (this.context.content) {
                return (React.createElement("div", { className: "iframe__consent" },
                    React.createElement("div", { className: "iframe__consent-inner" },
                        React.createElement(Notice, { direction: "vertical" },
                            React.createElement(Text, null,
                                React.createElement(Heading, { level: consentHeadingLevel, className: "h2" }, this.context.content.title),
                                React.createElement("p", { className: "text__margin-double" }, this.context.getDescription(needsConsent)),
                                React.createElement("p", { className: "text__margin-double" },
                                    React.createElement(Button, Object.assign({}, this.context.content.button, { variant: "secondary", iconRight: "#arrow-right" }))))))));
            }
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("iframe", { ref: (element) => this.iframe = element, key: this.props.url, src: this.props.url, title: this.props.title, allow: this.props.allow, className: "iframe__content", onLoad: this.handleLoad, onError: this.handleError, style: { minHeight: this.props.minHeight } }),
            !this.state.hasLoaded && React.createElement(Overlay, { spinner: true })));
    }
    render() {
        return (React.createElement("div", { className: this.BEM() }, this.renderContent()));
    }
}
IframeCore.contextType = CookieConsentContext;
IframeCore.defaultProps = {
    needsConsent: ['necessary'],
    consentHeadingLevel: 1,
};
